"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { AboutCapabilities } from "@/components/about/AboutCapabilities";
import styles from "./WhatIsPageView.module.css";

/** Product landing for producers, separated from GRUV's company story. */
export function WhatIsPageView() {
  const t = useTranslations("whatIs");
  const facts = t.raw("facts") as Array<{ label: string; value: string }>;

  return (
    <article className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.heroCopy}>
          <p className={styles.eyebrow}>{t("eyebrow")}</p>
          <h1>{t("title")}</h1>
          <p className={styles.lede}>{t("intro")}</p>
          <div className={styles.actions}>
            <a className={styles.primaryCta} href="https://manager.gruv.fm">
              {t("managerCta")}
            </a>
            <Link className={styles.secondaryCta} href="/contact">
              {t("demoCta")}
            </Link>
          </div>
        </div>
        <div className={styles.heroSystem} aria-hidden="true">
          <div className={styles.heroTicket}>
            <b>GRUV</b>
            <span>LIVE</span>
          </div>
          <div className={styles.heroOrbit}>
            <span />
            <span />
            <span />
          </div>
          <div className={styles.heroSignal} />
          <p>EVENTS / PEOPLE / TECHNOLOGY</p>
        </div>
      </header>

      <section className={styles.promise} aria-label={t("factsLabel")}>
        {facts.map((fact) => (
          <div key={fact.label}>
            <strong>{fact.value}</strong>
            <span>{fact.label}</span>
          </div>
        ))}
      </section>

      <AboutCapabilities />

      <section className={styles.audience}>
        <div className={styles.audienceCopy}>
          <p className={styles.eyebrow}>{t("audience.eyebrow")}</p>
          <h2>{t("audience.title")}</h2>
          <p>{t("audience.body")}</p>
        </div>
        <div className={styles.audienceLoop} aria-hidden="true">
          <span>DESCUBRIR</span>
          <i>→</i>
          <span>COMPRAR</span>
          <i>→</i>
          <span>ENTRAR</span>
          <i>→</i>
          <span>COMPARTIR</span>
        </div>
      </section>

      <footer className={styles.closing}>
        <p>{t("closing.eyebrow")}</p>
        <h2>{t("closing.title")}</h2>
      </footer>
    </article>
  );
}
